/* Wortzeichen wie auf byliox.dev: Archivo extra-breit, Suffix in Mono und Akzentfarbe. */
.mark {
  display: inline-flex;
  align-items: baseline;
  font-size: 1.375rem;
  font-weight: 850;
  font-stretch: 125%;
  letter-spacing: -0.04em;
  line-height: 1;
  color: var(--text-primary);
}

.suffix {
  margin-left: 3px;
  font-family: var(--font-mono);
  font-size: 0.62em;
  font-weight: 500;
  font-stretch: 100%;
  letter-spacing: 0;
  color: var(--accent-text);
}

.logo {
  align-self: center;
  width: 1.05em;
  height: 1.05em;
  margin-right: 0.45em;
  color: var(--accent);
}
